import { useState } from 'react';
import './Header.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import MyOrders from '../user_profile/MyOrders';
import { performLogOut, fetchUserInfo, setLoggedIn } from '../../store';
import config from '../../config.json';
import useMediaQuery from '@mui/material/useMediaQuery';
import { signInWithGoogle } from '../../firebase/authHelpers';
import axios from 'axios';
import { toast } from 'react-toastify';

const Header = ({ search, setSearch, setShowCart }) => {
  const [showOrders, setShowOrders] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const isMobile = useMediaQuery('(max-width: 768px)');

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const loggedIn = useSelector(state => state.auth.loggedIn);
  const role = useSelector(state => state.user?.role);
  // Sum all quantities in cart for total count
  const cartCount = useSelector(state => state.cart?.items?.reduce((sum, item) => sum + 1, 0));

  const handleLogoClick = () => {
    navigate('/');
  };

  const handleFirebaseLogin = async () => {
    try {
      const { idToken, googleProfile } = await signInWithGoogle();

      // Send token to backend (first/last from Google OIDC profile when present)
      const baseUrl = config.api.baseUrl || "http://localhost:8000";
      await axios.post(
        `${baseUrl}/api/auth/firebase-login`,
        {
          idToken,
          ...(googleProfile && {
            firstName: googleProfile.givenName,
            lastName: googleProfile.familyName
          })
        },
        { headers: { Authorization: `Bearer ${idToken}` } }
      );

      dispatch(setLoggedIn(true));
      dispatch(fetchUserInfo());
      toast.success('Logged in successfully!');
    } catch (error) {
      if (error.code === 'auth/popup-closed-by-user') {
        return; // Silent failure - user intentionally closed popup
      }
      if (error.code === 'auth/popup-blocked') {
        toast.error('Popup blocked. Please allow popups for this site.');
        return;
      }
      console.error('Login error:', error);
      toast.error('Login failed. Please try again.');
    }
  };

  const handleFirebaseLogout = async () => {
    try {
      await dispatch(performLogOut()).unwrap();
      navigate('/');
    } catch (error) {
      console.error('Logout error:', error);
      toast.error('Logout failed.');
    }
  };

  return (
    <>
      <header className="header">
        <div className="nav-container">
          <div className="nav-left">
            <img
              style={{ maxHeight: "50px", height: "50px", objectFit: "contain", cursor: "pointer" }}
              src="/images/products/sri-shiv-logo.png"
              alt="Sri Shiv Logo"
              onClick={handleLogoClick}
              onKeyDown={(e) => e.key === 'Enter' && handleLogoClick()}
              tabIndex={0}
              role="button"
            />
            <img
              style={{ maxHeight: "50px", height: "50px", marginLeft: "0", objectFit: "contain", cursor: "pointer" }}
              src="/images/products/sri-shiv-logo-text.png"
              alt="Sri Shiv Enterprises"
              onClick={handleLogoClick}
              onKeyDown={(e) => e.key === 'Enter' && handleLogoClick()}
              tabIndex={0}
              role="button"
            />
          </div>

          {/* Desktop Navigation (hidden if isMobile) */}
          <div className="nav-right desktop-nav">
            {!isMobile && (<div className="search-container">
              {location.pathname === "/" && (
                <input
                  type="text"
                  className="search-input"
                  placeholder="Search paper bags..."
                  value={search}
                  onChange={e => setSearch?.(e.target.value)}
                />
              )}
            </div>)}
            {!isMobile && (<div className="nav-text-links">
               {loggedIn && role === 'admin' && <button
                className="nav-text-btn"
                onClick={() => navigate('/users')}
              >
                Users
              </button>}
              {loggedIn && (role === 'admin' || role === 'oper') && <button
                className="nav-text-btn"
                onClick={() => navigate('/products')}
              >
                Products
              </button>}
              {loggedIn && <button
                className="nav-text-btn"
                onClick={() => navigate('/user-profile')}
              >
                Profile
              </button>}
              {loggedIn && role !== 'user' && <button
                className="nav-text-btn"
                onClick={() => navigate('/orders')}
              >
                Orders
              </button>}
              {loggedIn && role === 'user' && <button
                className="nav-text-btn"
                onClick={() => setShowOrders(true)}
              >
                Orders
              </button>}
              {loggedIn && role === 'user' && <button
                className="nav-text-btn"
                onClick={() => setShowCart?.(true)}
              >
                Cart{cartCount > 0 && <span className="cart-count-badge">{cartCount}</span>}
              </button>}
              {loggedIn ? (
                <button
                  className="nav-text-btn"
                  onClick={handleFirebaseLogout}
                >
                  Logout
                </button>
              ) : (
                <button
                  className="nav-text-btn"
                  onClick={handleFirebaseLogin}
                >
                  Login
                </button>
              )}
            </div>)}
          </div>

          {/* Mobile Burger Menu Button */}
          <button
            className="mobile-menu-toggle"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle mobile menu"
          >
            <span className={`burger-line ${isMobileMenuOpen ? 'open' : ''}`}></span>
            <span className={`burger-line ${isMobileMenuOpen ? 'open' : ''}`}></span>
            <span className={`burger-line ${isMobileMenuOpen ? 'open' : ''}`}></span>
          </button>
        </div>

        {/* Mobile Navigation Menu */}
        {isMobile && (<div className={`mobile-nav ${isMobileMenuOpen ? 'open' : ''}`}>

          <div className="mobile-nav-links">
            {loggedIn && role === 'admin' &&(
              <button
                className="mobile-nav-btn"
                onClick={() => {
                  navigate('/users');
                  setIsMobileMenuOpen(false);
                }}
              >
                Users
              </button>
            )}
            {loggedIn && (role === 'admin' || role === 'oper') &&(
              <button
                className="mobile-nav-btn"
                onClick={() => {
                  navigate('/products');
                  setIsMobileMenuOpen(false);
                }}
              >
                Products
              </button>
            )}
            {loggedIn && (
              <button
                className="mobile-nav-btn"
                onClick={() => {
                  navigate('/user-profile');
                  setIsMobileMenuOpen(false);
                }}
              >
                Profile
              </button>
            )}
            {loggedIn && role === 'user' &&(
              <button
                className="mobile-nav-btn"
                onClick={() => {
                  setShowOrders(true);
                  setIsMobileMenuOpen(false);
                }}
              >
                Orders
              </button>
            )}
            {loggedIn && role !== 'user' && (
              <button
                className="mobile-nav-btn"
                onClick={() => {
                  navigate('/orders');
                  setIsMobileMenuOpen(false);
                }}
              >
                Orders
              </button>
            )}
            {loggedIn && role === 'user' && (
              <button
                className="mobile-nav-btn"
                onClick={() => {
                  setShowCart?.(true);
                  setIsMobileMenuOpen(false);
                }}
              >
                Cart{cartCount > 0 && <span className="cart-count-badge-mobile">{cartCount}</span>}
              </button>
            )}
            {loggedIn ? (
              <button
                className="mobile-nav-btn"
                onClick={() => {
                  handleFirebaseLogout();
                  setIsMobileMenuOpen(false);
                }}
              >
                Logout
              </button>
            ) : (
              <button
                className="mobile-nav-btn"
                onClick={() => {
                  handleFirebaseLogin();
                  setIsMobileMenuOpen(false);
                }}
              >
                Login
              </button>
            )}
          </div>
        </div>)}
        {isMobile && !isMobileMenuOpen && location.pathname === "/" && (
          <div className="mobile-search">
            <input
              type="text"
              className="search-input mobile-search-input"
              placeholder="Search paper bags..."
              value={search}
              onChange={e => setSearch?.(e.target.value)}
            />
          </div>
        )}
      </header>
      {showOrders && role === 'user' && (
        <div
          className="myorders-modal-overlay"
          onClick={() => setShowOrders(false)}
          onKeyDown={(e) => e.key === 'Escape' && setShowOrders(false)}
          role="dialog"
          tabIndex={-1}
        >
          <div
            className="myorders-modal-content"
            onClick={e => e.stopPropagation()}
            role="document"
          >
            <button className="myorders-modal-close" aria-label="Close" onClick={() => setShowOrders(false)}>&times;</button>
            <MyOrders />
          </div>
        </div>
      )}
    </>
  );
};

export default Header;